/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory as createHistory } from "history";
import App from "./App";
import "./styles/main.css";

// basename for akamai routing.
const basename = "/contentadmin";
const history = createHistory({ basename });

ReactDOM.render(<App history={history} />, document.getElementById("root"));




// WEBPACK FOOTER //
// ./src/index.js